<template>
  <div>
    <main class="bg_gray pattern login-container">
      <div class="container margin_60_40">
        <form-wrapper :validator="$v.user">
          <div class="row justify-content-center login-area">
            <div class="col-lg-4">
              <div class="sign_up">
                <div class="head">
                  <div class="title">
                    <h3>Sign in</h3>
                  </div>
                </div>
                <!-- /head -->
                <div class="main back-white">
                  <div class="alert alert-error mb-20" v-if="failed">
                    Login failed. Please make sure the credential is correct
                  </div>
                  <div v-if="!loading">
                    <div class="form-group">
                      <BaseInput
                        v-model="user.username"
                        type="text"
                        id="login-username"
                        name="login-username"
                        placeholder="Username"
                        size="lg"
                        @onEnter="Login()"
                      />
                      <!-- <input class="form-control" placeholder="Email Address" /> -->
                      <i class="icon_info_alt"></i>
                    </div>
                    <div class="form-group" v-if="!accessChoices.length">
                      <BaseInput
                        v-model="user.password"
                        type="password"
                        id="login-password"
                        name="login-password"
                        placeholder="Password"
                        size="lg"
                        @onEnter="Login()"
                      />

                      <i class="icon_lock"></i>
                    </div>
                    <div v-else class="access-picker">
                      <p class="access-picker__lead">
                        This account can open more than one screen. Choose one to continue. You sign in to only that screen.
                      </p>
                      <button
                        v-for="choice in accessChoices"
                        :key="choice.value"
                        type="button"
                        class="access-choice"
                        @click="chooseAccess(choice.value)"
                      >
                        <span class="access-choice__title">{{ choice.label }}</span>
                        <span class="access-choice__hint">{{ accessHint(choice.value) }}</span>
                      </button>
                      <button type="button" class="access-picker__back" @click="clearAccessChoice">
                        Back to password
                      </button>
                    </div>
                  </div>

                  <Loader v-else :loading="loading" :success="loginSuccess" />
                  <b-button
                    v-if="!accessChoices.length"
                    variant="primary"
                    type="submit"
                    class="btn-primary btn_1 full-width mb_5 mt-35"
                    @click="Login()"
                  >
                    <!-- <b-spinner v-if="loading" type="border" small></b-spinner> -->
                    <div v-if="!loading">
                      <i class="fa fa-fw fa-sign-in mr-1"></i>
                      Sign In
                    </div>
                  </b-button>
                </div>
              </div>
              <!-- /box_booking -->
            </div>
            <!-- /col -->
          </div>
          <!-- /row -->
        </form-wrapper>
        <!-- Footer -->
        <div class="font-size-s2 m text-center login-credit py-3">
          <strong>Speed Code Labs</strong> &copy;
          <span data-toggle="year-copy"></span>
        </div>
        <!-- END Footer -->
      </div>
      <!-- /container -->
    </main>
  </div>
</template>
<script>
import { Input as BaseInput, Loader } from "@/components/base/index.js";
import { required } from "vuelidate/lib/validators";
import { mapState, mapGetters } from "vuex";
import { getDefaultRouteForToken, getValidToken } from "@/utils/auth";

export default {
  name: "Login",
  layout: "none",
  components: {
    BaseInput,
    Loader,
  },
  data: () => ({
    loading: false,
    failed: false,
    loginSuccess: false,
    accessChoices: [],
    user: {
      username: "",
      password: "",
      usertype: null,
    },
  }),
  mounted: function () {
    if (!this.isAuthenticated) {
      return;
    }
    const redirect = this.$route.query.redirect;
    if (redirect && redirect !== "/login") {
      this.$router.replace(redirect);
      return;
    }
    const token = getValidToken();
    this.$router.replace(getDefaultRouteForToken(token));
  },
  computed: {
    ...mapState("auth", ["status"]),
    ...mapGetters("auth", ["IsAuthenticated"]),
    isAuthenticated() {
      return this.IsAuthenticated;
    },
  },
  methods: {
    async Login() {
      this.loading = true;
      this.failed = false;
      this.$v.$touch(); //it will validate all fields
      if (!this.$v.$invalid) {
        this.$store
          .dispatch("auth/Login", this.user)
          .then((res) => {
            const data = res && res.data ? res.data : {};
            if (data.chooseAccess) {
              this.loading = false;
              this.accessChoices = data.accessTypes || [];
              return;
            }
            this.loginSuccess = true;
            this.GetSetting();
            setTimeout(() => {
              const redirect = this.$route.query.redirect;
              if (redirect && redirect !== "/login") {
                this.$router.push(redirect);
                return;
              }
              const token = getValidToken();
              this.$router.push(getDefaultRouteForToken(token));
            }, 700);
          })
          .catch((err) => {
            this.loading = false;
            this.loginSuccess = false;
            this.failed = true;
            this.accessChoices = [];
            this.user.usertype = null;

            this.user.username = "";
            this.user.password = "";
            this.$v.$reset();
          });
      } else {
        this.loading = false;
      }
    },
    chooseAccess(type) {
      this.user.usertype = type;
      this.Login();
    },
    clearAccessChoice() {
      this.accessChoices = [];
      this.user.usertype = null;
    },
    accessHint(value) {
      const hints = {
        1: "Opens the order screen. Take table orders and prepare the bill.",
        2: "Opens the kitchen display. See tickets and update cooking status.",
        3: "Opens the waiter screen. Serve your tables and follow your orders.",
      };
      return hints[Number(value)] || "";
    },
    GetSetting() {
      this.$store
        .dispatch("sitesetting/GetSettings")
        .then((res) => {
          // this.kotsetting = res.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
  },
  validations: {
    user: {
      username: { required },
      password: { required },
    },
  },
};
</script>

<style>
.login-form {
  width: 50%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  /* padding: 255px 52px; */
  padding: 170px 48px;
}
.login-more {
  width: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;
}

.wrap-login {
  border-radius: 20px;
  width: 890px;
  background: #fff;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  flex-direction: row-reverse;
}
.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: #f2f2f2;
}
.login-form * {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
.br-15 {
  border-radius: 15px;
}
.login-container {
  height: 100vh;
}
.login-area {
  margin-top: 75px;
}
.mt-35 {
  margin-top: 35px;
}
.mb-20 {
  margin-bottom: 20px !important;
}
.alert {
  position: relative;
  display: block;
  padding: 1em 1.8em;
  font-size: 0.9em;
  font-weight: 300;
  line-height: 1.2;
  text-align: left;
  margin-top: 0.4em;
  margin-bottom: 0.4em;
  background: transparent;
  color: white;
}

/* Error */
.alert-error {
  /* background: #da1414; */
  /* border: 1px solid #c0392b; */
  border: 1px solid #c0392b;
  color: #da1414;
}

.sign_up .access-picker {
  margin-top: 6px;
}

.sign_up .access-picker__lead {
  margin: 0 0 16px;
  color: #3d4a54;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

.sign_up .access-choice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  margin: 0 0 12px;
  padding: 14px 16px;
  text-align: left;
  background: #ffffff;
  border: 1px solid #d5dee3;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.sign_up .access-choice:last-of-type {
  margin-bottom: 4px;
}

.sign_up .access-choice:hover,
.sign_up .access-choice:focus {
  border-color: var(--brand-primary, #14808c);
  background: #f3fbfb;
  outline: none;
}

.sign_up .access-choice__title {
  color: #16323a;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.sign_up .access-choice__hint {
  color: #5c6b73;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
}

.sign_up .access-picker__back {
  display: block;
  width: 100%;
  margin-top: 14px;
  padding: 8px;
  border: none;
  background: transparent;
  color: var(--brand-primary, #14808c);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.login-credit {
  color: #3d4a54;
}

/* The sign-in card stays white. Dark mode must not hide the instructions. */
html.kot-dark .login-container .sign_up .main,
html.kot-dark .login-container .sign_up .access-choice {
  background: #ffffff !important;
  color: #16323a !important;
}

html.kot-dark .login-container .sign_up .access-picker__lead,
html.kot-dark .login-container .sign_up .access-choice__title {
  color: #16323a !important;
}

html.kot-dark .login-container .sign_up .access-choice__hint,
html.kot-dark .login-container .login-credit {
  color: #5c6b73 !important;
}

html.kot-dark .login-container .sign_up .access-picker__back {
  background: transparent !important;
  color: #0e7490 !important;
}
</style>
